import { Text, Link } from 'braid-design-system';

import TrackingLink from 'src/views/shared/TrackingLink/TrackingLink';

import * as styles from './TabItem.css';

interface Props {
  tabName: string;
  isSelected: boolean;
  tabRef: string;
  analyticsEvent: string;
  analyticsOrigin: string;
  onClick: (event: Event, params: Record<string, unknown>) => void;
}

const TabItem = ({
  tabName,
  isSelected,
  tabRef,
  analyticsEvent,
  analyticsOrigin,
  onClick,
}: Props) => (
  <li className={styles.root} ref={tabRef}>
    <TrackingLink
      renderAs={Link}
      href="#"
      className={styles.link}
      data-analytics={analyticsEvent}
      data-analytics-origin={analyticsOrigin}
      onClick={onClick}
    >
      <Text
        size="large"
        tone={isSelected ? 'neutral' : 'secondary'}
        weight={isSelected ? 'medium' : 'regular'}
      >
        {tabName}
      </Text>
    </TrackingLink>
  </li>
);

export default TabItem;
